<template>
  <intersect @enter="animate = true">
    <section class="container program-content fadeUp" :class="animate ? 'animate' : '' ">
      <div
        class="overview-container flex-box mt-55"
        :class="direction === 'standard' ? 'row-standard' : 'row-reverse'"
      >
        <div class="overview-left">
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="_.get(itemData, 'images.0.devices.mobile')"
              />
              <source
                media="(max-width: 1023px)"
                :srcset="_.get(itemData, 'images.0.devices.tablet')"
              />
              <img
                :src="_.get(itemData, 'images.0.devices.desktop')"
                class="img-absolute br-12"
                alt
              />
            </picture>
          </div>
        </div>
        <div class="overview-right">
          <h2 class="other-title">{{ _.get(itemData, "title") }}</h2>
          <div
            class="text mt-21"
            v-html="_.get(itemData, 'content.tabs.0.content')"
          ></div>
        </div>
      </div>
    </section>
  </intersect>
</template>

<script>
import Intersect from 'vue-intersect'
export default {
  props: {
    direction: {
      type: String,
      default: "standard",
    },
    
    itemData: {
      type: Object,
      required: true,
    },
  },
  components: { 
      Intersect
  },
  data(){
    return{
      animate: false,
    }
  }
};
</script>

<style scoped>
</style>
